<template>
    <div class="card grey lighten-4 z-depth-0">
        <div class="card-panel lighten-4 z-depth-0" v-if="client?.email">
            <!-- Pending -->
            <div class="card-content">
                <span class="card-title teal-text align-center">
                    <b>Portal Login <em>for</em> {{ client?.name }}</b> <span class="chip teal-text"> {{ client?.name
                    }}</span>
                </span>
                <div class="divider"></div>
            </div>
            <div class="card-content">
                <span class="card-title black-text">
                    Dear {{ client?.name }},
                    <br /><br />
                    You're organization is now live on our platform!
                    <br /><br />
                    Use the credentials below to login and connect with {{ HMO }}.
                    <br /><br />
                    <b>Portal Link</b>: {{ appURL }} <br />
                    <b>Username</b>: {{ client?.user_created === 'y' ? client?.users?.[0]?.email : client?.email }} <br />
                    <b>Password</b>:  (password will be auto-generated on first login)
                    <br /><br /><br />
                    Regards,
                    <br />
                    {{ HMO }}
                </span>

            </div>
        </div>
        <div class="card-panel z-depth-2" v-else>
            <div class="card-content">
                <span class="card-title teal-text align-center">
                    <b>{{ client?.name }}</b> <span class="chip red lighten-5 red-text"> Missing Email Address
                        {{ client?.name }}</span>
                </span>
                <div class="divider"></div>
            </div>
            <div class="card-content">
                <span class="card-title black-text align-center">
                    Official email address not found for <b>{{ client?.name }}</b>.
                    Please add an email address to automatically generate login credentials.
                </span>
            </div>
        </div>
    </div>

</template>

<script>
import { HMO, appURL } from '@/laravel/config';

export default {
    name: "ClientAdminComponent",
    props: ["client"],
    setup(props) {
        console.log(props.client);
        return {
            HMO: HMO, 
            appURL: appURL,
        };
    },
};
</script>

<style scoped>
.progress {
    margin-top: -15px;
}

.grey-bg-custom {
    background-color: #f2f2f2;
}

.hover-text {
    cursor: pointer;
}

.clickable {
    cursor: pointer;
}
</style>